import React, { createContext, useEffect, useState,useMemo } from 'react';
export const LoginContext = createContext();

export const LoginContextProvider = ({ children }) => {
  const [islogin, setlogin] = useState(false);
  const [loginData, setLoginData] = useState(null);

  // previous login check

  useEffect(()=>{
  const sessionData = localStorage.getItem("customkey");
  if (sessionData !== null || sessionData!==undefined && loginData === null) {
    handleLogin(JSON.parse(sessionData));
    setlogin(true);
  }else{
    setlogin(false);
  }
  },[]);
  
  //login function
  const handleLogin = (userData) => {
    setlogin(true);
    setLoginData(userData);
    localStorage.setItem("customkey",JSON.stringify(userData));
    
  };

  
  //logout function
  const handleLogout = () => {
    setlogin(!islogin);
    setLoginData(null);
    localStorage.removeItem("customkey");
  };


  const loginContextValue = useMemo(
    () => ({
      loginData,
      handleLogin,
      handleLogout,
      islogin
    }),
    [loginData]
  );

  return (
    <LoginContext.Provider value={loginContextValue}>
      {children}
    </LoginContext.Provider>
  );
};